export default __webpack_public_path__ + "static/media/playPause.3caeb270.svg";